import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import RemovalSubSectionPage1 from "./removalSubsectionPage1";
import RemovalSubSectionPage2 from "./removalSubsectionPage2";
import moment from "moment";
import { useDispatch } from "react-redux";
import { assetSell, getFixedAssetDetailsLogs, getFixedAssetsList, simulationAssetSell } from "../../../../../store/actions/precog/assets";
import { openNotificationWithIcon } from "../../../../../libs/utils";
import { notification } from "antd";
import { useIntl } from "react-intl";

const RemovalSubSection = ({assetId, businessId, state, setBottomButtons, setHideHeader, setRemovalRevaluation}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  // TODO - check with Alessandro about the data from API
  const [removalState, setRemovalState] = useState({
    fiscalCapitalLoss: "NA",
    civilisticCapitalLoss: "NA"
  });
  const [fields, setFields] = useState({
    businessId: businessId,
    disposalRate: undefined,
    saleAmount:	0,
    date: undefined
  });
  const [page, setPage] = useState(1);
  const [isSimulationLoading, setIsSimulationLoading] = useState(false);
  const [simulationData, setSimulationData] = useState(null);
  
  useEffect(()=> {
    if (page===1) {
      setBottomButtons([<Button key={1} kind="primary" onClick={() => {
        setIsSimulationLoading(false);
        const cloneData = {...fields};
        cloneData.date = moment(cloneData.date).format("YYYY-MM-DD");
        dispatch(simulationAssetSell(assetId, cloneData))
          .then((data) => {
            setIsSimulationLoading(false);
            setSimulationData(data);
          })
          .catch((err) => {
            openNotificationWithIcon(err.message);
            setIsSimulationLoading(false);
          });
        setPage(2);
      }
      }>
        <FormattedMessage id="preCog.assetsTab.drawer.movements.next" /> 
      </Button>]);
    }
    if (page===2) {
      setBottomButtons([<Button key={2} kind="primary" onClick={() => {
        const cloneData = {...fields};
        cloneData.date = moment(cloneData.date).format("YYYY-MM-DD");
        dispatch(assetSell(assetId, cloneData))
          .then(() => {
            openNotificationWithIcon(
              notification,
              "success",
              "",
              intl.formatMessage({id: "preCog.assetsTab.drawer.movements.revaluationSuccess"}),
              null,
              null
            );
            setHideHeader(false);
            setRemovalRevaluation(false);
            dispatch(getFixedAssetDetailsLogs(assetId, businessId));
            dispatch(getFixedAssetsList(businessId));
          }).catch(() => {            
            openNotificationWithIcon(
              notification,
              "error",
              "",
              intl.formatMessage({id: "preCog.assetsTab.drawer.movements.revaluationError"}),
              null,
              null
            );
            setHideHeader(false);
            setRemovalRevaluation(false);
          });
      }}>
        <FormattedMessage id="preCog.assetsTab.drawer.movements.removeConfirm" />       
      </Button>]);
    }
  },[page, fields]);

  return (
    <>
      <div className='pre-cog-assets-drawer-revaluation-back'
        onClick={() => {
          setHideHeader(false);
          setRemovalRevaluation(false);
        }}>
        <FontAwesomeIcon
          style={{ color: "rgb(0, 144, 209)", cursor: "pointer" }}
          icon={["fal", "arrow-left"]}
        />
        <p className='pre-cog-assets-drawer-revaluation-back-label'>
          <FormattedMessage id="preCog.assetsTab.drawer.movements.backToMovements" />   
        </p>
      </div>
      <div className='pre-cog-assets-drawer-revaluation-title'>
        <FormattedMessage id="preCog.assetsTab.drawer.movements.delete" /> 
      </div>
      {page === 1 && <RemovalSubSectionPage1 state={state} fields={fields} setFields={setFields} removalState={removalState} setRemovalState={setRemovalState} />}
      {page === 2 && <RemovalSubSectionPage2 setPage={setPage} isSimulationLoading={isSimulationLoading} simulationData={simulationData} />}
    </>
  );
};

export default RemovalSubSection;
